<template>
    <div>
        <breadCrumb 
            :icon="'fa-tools'"
            :category="$t(`sideNav.navMySalon`)"
            :subCategory="$t(`subMenu.my_salon_branding`)"
            :subSubCategory="$t(`brand_submenu.brand_setup_configuration`)">
        </breadCrumb>
        <ul class="nav nav-tabs nav-tabs-clean px-3 px-sm-5 mt-3" role="tablist">
            <li class="nav-item" v-for="brandConfigTab in $i18n.messages[$i18n.locale].tab.brandConfigTabs" :key="brandConfigTab.id">
                <a class="nav-link  bg-transparent fs-lg fw-400" :class="{'active': selectedTab == brandConfigTab.id}" @click="selectedTab = brandConfigTab.id" >{{brandConfigTab.text}}</a>
            </li>
        </ul>
        <div class="tab-content mt-5">
            <div :class="{'active': selectedTab == 'membershipTag'}" class="tab-pane">
                <div class="px-3 px-sm-5 py-4">
                    <div class="panel mb-0">
                        <div class="panel-hdr">
                            <h2>{{$t('branding.header_member_tag')}}</h2>
                        </div>
                        <div class="panel-container">
                            <div class="panel-content">
                                <form @submit.prevent="submitBrandConfiguration" class="p-3">
                                    <div class="form-group row d-flex align-items-center" v-for="(vip, index) in vips" :key="index">
                                        <label class="form-label col-lg-1">{{vip.key}}</label>
                                        <i class="fas fa-arrows-alt-h col-lg-1"></i>
                                        <div class="input-group bg-white col-lg-10">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text bg-transparent border-right-0">
                                                    <i class="fas fa-user-circle"></i>
                                                </span>
                                            </div>
                                            <input type="text" class="form-control bg-transparent pl-3" :placeholder="vip.key" v-model="vip.value">
                                        </div>
                                    </div>
                                    <div class="text-left mb-3">
                                        <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div :class="{'active': selectedTab == 'memberInfo'}" class="tab-pane">
                <div class="px-3 px-sm-5 py-4">
                    <div class="panel mb-0">
                        <div class="panel-hdr">
                            <h2>{{$t('branding.header_member_info_title')}}</h2>
                        </div>
                        <div class="panel-container">
                            <div class="panel-content">
                                <form @submit.prevent="submitBrandConfiguration" class="p-3">
                                    <div class="form-group row d-flex align-items-center" v-for="(title, index) in titles" :key="index">
                                        <label class="form-label col-lg-2">{{$t('label.info')}} {{index + 1}}</label>
                                        <i class="fas fa-arrows-alt-h col-lg-1"></i>
                                        <div class="input-group bg-white col-lg-9">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text bg-transparent border-right-0">
                                                    <i class="fas fa-user-circle"></i>
                                                </span>
                                            </div>
                                            <input type="text" class="form-control bg-transparent pl-3" :placeholder="'Information ' + (index + 1)" v-model="titles[index]">
                                        </div>
                                    </div>
                                    <div class="text-left mb-3">
                                        <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BreadCrumb from './../../Bread_Crumb'
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'

export default {
    name: 'brandConfiguration',
    components:{
        BreadCrumb
    },
    data(){
        let selectedtab = this.$i18n.messages[this.$i18n.locale].tab.brandConfigTabs[0].id
        return{
            selectedTab: selectedtab,
            vips: [], titles: []
        }
    },
    methods:{
        closeModal(isError){
            if(!isError){
                this.selectedTab = 'membershipTag'
                this.getBrandConfiguration()
            }
            this.$parent.isModalShow = false;
        },
        submitBrandConfiguration(){
            let $vm = this
            var vips = []
            for(var i=0; i<this.vips.length; i++){
                vips.push(this.vips[i].value)
            }
            var data = {
                vip: vips,
                title: this.titles
            }
            this.$axios({
                method: 'post', 
                url: this.$api.BRAND_CONFIG,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()},
                data: data
            })
            .then((response) => {
                if(response.status == 200){
                    var message = $vm.$i18n.t('subMenu.my_salon_branding') + $vm.$i18n.t('brand_submenu.brand_setup_configuration') + $vm.$i18n.t('message.success.update')
                    $vm.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }else{
                    this.$parent.setModal(this, true, true, $vm.$i18n.$t('message.error.system_error'));
                }
            })
        },
        getBrandConfiguration(){
            let $vm = this;
            var init = ["VIP", "VVIP", "VVVIP"];
            $vm.vips = []
            $vm.titles = []

            $vm.$axios({
                method: 'get', 
                url: $vm.$api.BRAND_CONFIG,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                var results = response.data;
                $vm.titles = results.title;

                for(var i=0; i<results.vip.length; i++){
                    $vm.vips.push({key: init[i], value: results.vip[i]})
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        }
    },
    mounted(){
        let $vm = this;
        $vm.getBrandConfiguration();
    }
}
</script>
